import { Toro } from '../common/enumerations';

export class Kd2SpecificConfiguration
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }
    }

    ClmControlledManualOpOccurring: Toro.ClmControlledManualOperation;
    ClmTestAllMinutesRemaining: number;
    CurrentWateringModeActivationReason: Toro.CurrentWateringModeActivationReason;
    IsClmVirtualSensorActive: boolean;
    IsHwRainSensorActive: boolean;
    IsRainSensorTerminalEnabled: boolean;
    RuntimeDurationFormat: number;
    SerialNumber: number;
    WateringChanged: boolean;

}
